import RoutesPage from '../src/Routes/Routes'

function App() {
  return (
    <div className="App">
      <RoutesPage />
    </div>
  );
}

export default App;
